import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/cost_groups', { params });
  },
  create(data) {
    return axios.post('/v1/cost_groups', data);
  },
  detail(id) {
    return axios.get(`/v1/cost_groups/${id}`);
  },
  update(id, params) {
    return axios.put(`/v1/cost_groups/${id}`, params);
  }
};
